export enum DBTransactionType {
  split = 'split',
  merge = 'merge',
  update = 'update',
}
